import React, { useState, useEffect } from 'react';
// import Input from './Input';
import { useTranslation } from 'react-i18next';
import RadioButtonGroup from './RadioButtonGroup';
import TextArea from './TextArea';
import { useSession } from '../context/SessionContext';
import toast from 'react-hot-toast';
import Button from './Button';
import MyText from './MyText';
import Select from './Select';
import { useApi } from '../context/ApiContext';

export default function StepCandidatura({ nextCallback }) {
    const { session, saveSession } = useSession();
    const { fieldsCV, getAllFieldValues, getFieldValues } = useApi();
    // const [selectOptions, setSelectOptions] = useState([]);
    const [tipologiaOptions, setTipologiaOptions] = useState([]);
    const [strutturaOptions, setStrutturaOptions] = useState([]);
    const [titoloOptions, setTitoloOptions] = useState([]);
    const [diplomaOptions, setDiplomaOptions] = useState([]);
    const [funzioneOptions, setFunzioneOptions] = useState([]);
    const { t } = useTranslation();
    const [state, setState] = React.useState({
        tipologiaDiCandidatura: session.tipologiaDiCandidatura ? session.tipologiaDiCandidatura : '',
        titoloDiStudio: session.titoloDiStudio ? session.titoloDiStudio : '',
        diplomaOttenutoA: session.diplomaOttenutoA ? session.diplomaOttenutoA : '',
        funzione: session.funzione ? session.funzione : '',
        riferimentoCandidatura: session.riferimentoCandidatura ? session.riferimentoCandidatura : '',
        note: session.note ? session.note : ''
    });

    useEffect(() => {
        const populateSelect = async () => {
            if (fieldsCV.length === 0) return;

            const aField = fieldsCV
                .filter(item => item.externalId === "TitoloDiStudio" || item.externalId === "Funzione" || item.externalId === "DiplomaOttenutoA" || item.externalId === "TipologiaCandidatura" || item.externalId === "RiferimentoCandidatura");
            const tit = aField.find(x => x.externalId === 'TitoloDiStudio');
            const funz = aField.find(x => x.externalId === 'Funzione');
            const dip = aField.find(x => x.externalId === 'DiplomaOttenutoA');
            const tip = aField.find(x => x.externalId === 'TipologiaCandidatura');
            const rif = aField.find(x => x.externalId === 'RiferimentoCandidatura');
            const titRes = tit ? await getFieldValues(tit.name) : [];
            const funzRes = funz ? await getFieldValues(funz.name) : [];
            const dipRes = dip ? await getFieldValues(dip.name) : [];
            const tipRes = tip ? await getFieldValues(tip.name) : [];
            const rifRes = rif ? await getFieldValues(rif.name) : [];

            const titOptions = titRes.reduce((acc, item) => {
                acc.push({
                    code: item,
                    name: item,
                })
                return acc
            }, []);

            const funzOptions = funzRes.reduce((acc, item) => {
                acc.push({
                    code: item,
                    name: item,
                })
                return acc
            }, []);

            const dipOptions = dipRes.reduce((acc, item) => {
                acc.push({
                    code: item,
                    name: item,
                })
                return acc
            }, []);

            const tipOptions = tipRes.reduce((acc, item) => {
                acc.push({
                    code: item,
                    name: item,
                })
                return acc
            }, []);

            const rifOptions = rifRes.reduce((acc, item) => {
                acc.push({
                    code: item,
                    name: item,
                })
                return acc
            }, []);

            setTitoloOptions(titOptions);
            setDiplomaOptions(dipOptions);
            setStrutturaOptions(rifOptions);
            setFunzioneOptions(funzOptions);
            setTipologiaOptions(tipOptions);
        };
        populateSelect();
    }, [fieldsCV]);

    const handleChange = (e, property) => {
        // console.log("stato", state);
        setState({
            ...state,
            [property]: e.target.value,
        });
    }
    const handleRadioChange = (x, property) => {
        // console.log("stato", state);
        setState({
            ...state,
            [property]: x,
        });
    }

    const isCandidaturaComplete = () => {
        return state.titoloDiStudio && state.diplomaOttenutoA && state.funzione &&
            (strutturaOptions.length === 1 || state.riferimentoCandidatura) && (tipologiaOptions.length === 1 || state.tipologiaDiCandidatura);
    }
    const handleSalva = () => {
        var bValid = isCandidaturaComplete();
        if (!bValid) {
            toast.error(t('form_error'));
            return;
        }
        saveSession({
            ...state,
            riferimentoCandidatura: strutturaOptions.length === 1 ? strutturaOptions[0].name : state.riferimentoCandidatura,
            tipologiaDiCandidatura: tipologiaOptions.length === 1 ? tipologiaOptions[0].name : state.tipologiaDiCandidatura
        });
        nextCallback && nextCallback();
    };

    return (
        <div style={styles.container}>
            {tipologiaOptions.length > 1 && <Select label={t('step2_tipologiaLabel')} value={state.tipologiaDiCandidatura} onChange={(e) => handleChange(e, "tipologiaDiCandidatura")} data={tipologiaOptions} />}
            <Select label={t('step2_titoloStudioLabel')} value={state.titoloDiStudio} onChange={(e) => handleChange(e, "titoloDiStudio")} data={titoloOptions} />
            <Select label={t('step2_luogoDiplomaLabel')} value={state.diplomaOttenutoA} onChange={(e) => handleChange(e, "diplomaOttenutoA")} data={diplomaOptions} />
            <Select label={t('step2_professioneLabel')} value={state.funzione} onChange={(e) => handleChange(e, "funzione")} data={funzioneOptions} />
            {strutturaOptions.length > 1 && <Select label={t('step2_strutturaLabel')} value={state.riferimentoCandidatura} onChange={(e) => handleChange(e, "riferimentoCandidatura")} data={strutturaOptions} />}
            <TextArea label={t('step2_commentoLabel')} onChange={(e) => handleChange(e, "note")} />
            <div style={{ height: 0 }} />
            <div style={styles.buttonContainer}>
                <Button onClick={handleSalva}>
                    <MyText>{t('form_salvaProsegui')}</MyText>
                </Button>
            </div>
        </div>
    );
};
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 40,
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 40
    }
}